document.addEventListener("DOMContentLoaded", () => {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll("[data-gsap-ti-drape]").forEach((section) => {
    const values = section.querySelectorAll(".ti-drape__stat-value");
    if (!values.length) return;

    values.forEach((el) => {
      const endValue = parseFloat(el.dataset.count) || 0;
      const suffix = el.dataset.suffix || "";
      const decimals = endValue % 1 !== 0 ? 1 : 0;

      const counter = { val: 0 };

      gsap.to(counter, {
        val: endValue,
        duration: 1.2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: section,
          start: "top 70%",
          once: true
        },
        onUpdate: () => {
          el.textContent = counter.val.toFixed(decimals) + suffix;
        }
      });
    });
  });
});




















// console.log("TEXT IMAGE DRAPE LOADED");

// document.addEventListener("DOMContentLoaded", () => {
//   if (!window.gsap || !window.ScrollTrigger) return;

//   gsap.registerPlugin(ScrollTrigger);

//   document.querySelectorAll("[data-gsap-ti-drape]").forEach((section) => {
//     const values = section.querySelectorAll(".ti-drape__stat-value");

//     if (!values.length) return;

//     values.forEach((el) => {
//       const endValue = parseInt(el.dataset.count, 10) || 0;
//       const suffix = el.dataset.suffix || "";

//       const counter = { val: 0 };

//       gsap.to(counter, {
//         val: endValue,
//         duration: 1.2,
//         ease: "power2.out",
//         scrollTrigger: {
//           trigger: section,
//           start: "top 70%",
//           once: true
//         },
//         onUpdate: () => {
//           el.textContent = Math.round(counter.val) + suffix;
//         }
//       });
//     });
//   });
// });










// console.log("GSAP TEXT IMAGE DRAPE LOADED");

// document.addEventListener("DOMContentLoaded", () => {
//   if (!window.gsap || !window.ScrollTrigger) return;

//   gsap.registerPlugin(ScrollTrigger);

//   document.querySelectorAll("[data-gsap-ti-drape]").forEach((section) => {
//     const counters = section.querySelectorAll("[data-count]");

//     if (!counters.length) return;

//     counters.forEach((el) => {
//       const target = parseInt(el.dataset.count, 10);

//       gsap.fromTo(
//         el,
//         { innerText: 0 },
//         {
//           innerText: target,
//           duration: 1.2,
//           ease: "power2.out",
//           snap: { innerText: 1 },
//           scrollTrigger: {
//             trigger: section,
//             start: "top 70%",
//             once: true
//           },
//           onUpdate: function () {
//             el.innerText = Math.floor(el.innerText);
//           }
//         }
//       );
//     });
//   });
// });
